import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import { css } from "@emotion/react";
import { PrimaryLink } from "components/Links";
import { withIcon, ICON_TYPE, ICON_SIZE } from "components/Icon";
import { useInterviewQuestionAIVideoContext } from "hooks";

/**
 * InterviewQuestionVideoActionTrigger
 *
 * @param {Object} question   The interview question object for which the video action will be triggered.
 *
 * This component renders a link/button that allows users to either upload a new video or replace an existing one for a given interview question.
 * The text of the link changes based on whether a video already exists for the question. When clicked, it opens the video action modal using context.
 */
const InterviewQuestionVideoActionTrigger = ({ question }) => {
  const { openVideoActionModal } = useInterviewQuestionAIVideoContext();

  return (
    <VideoActionLink as="button" type="button" css={styles.trigger} onClick={() => openVideoActionModal(question)}>
      <FormattedMessage id="Missions.Roles.RoleVetting.Interviews.VideoAction.Replace" />
    </VideoActionLink>
  );
};

const VideoActionLink = withIcon(PrimaryLink, {
  type: ICON_TYPE.upload,
  size: ICON_SIZE.xlarge,
  color: "inherit",
  position: "relative",
});

const styles = {
  trigger: css`
    display: inline-flex;
    align-items: center;
    gap: 1rem;
    border: none;
    background: none;
    font-weight: 600;
    padding: 0;
    cursor: pointer;

    &:hover {
      opacity: 0.8;
    }
  `,
  spinner: css`
    margin-left: 0.8rem;
  `,
};

InterviewQuestionVideoActionTrigger.propTypes = {
  question: PropTypes.object.isRequired,
};

export default InterviewQuestionVideoActionTrigger;
